import React from "react";
import { useStore } from "../../store/store";
import { useMediaQuery } from "@mui/material";
import { woodImgs } from "./defaults";

interface ClickUpdate {
  woodSpecies: string;
  woodAbbrev: string;
  stainColor?: string;
  stain?: string;
  customPaintOrStain?: string;
  paintColor?: string;
  paintAndPrime?: string;
  prime?: string;
}

function useWoodSelector() {
  const largeScreen = useMediaQuery("(min-width:1300px)", { noSsr: true });

  const addToQuote = useStore((state) => state.addToQuote);

  const doorType = useStore((state) => state.quote.doorType);

  const materialChoice = useStore((state) => state.quote.material);

  const woodSpecies = useStore((state) => state.quote.woodSpecies);

  const woodObj = !woodSpecies
    ? { imgLabel: "" }
    : woodImgs.find((obj) => obj.label === woodSpecies);

  const handleClick = (label: string, woodAbbrev: string) => {
    const checked = checkMark(label);

    if (checked) return;

    let update: ClickUpdate = {
      woodSpecies: label,
      woodAbbrev: woodAbbrev,
    };

    if (label.includes("Paint-Grade")) {
      update["stainColor"] = "";
      update["stain"] = "";
      update["customPaintOrStain"] = "";
    } else if (!label.includes("Paint-Grade")) {
      update["paintColor"] = "";
      update["paintAndPrime"] = "";
      update["prime"] = "";
      update["customPaintOrStain"] = "";
    }

    addToQuote(update);
  };

  const variant = (label: string) =>
    label === woodSpecies ? "filled" : "outlined";

  const checkMark = (label: string) => label === woodSpecies;

  const chipMaterial = materialChoice === "All Wood" ? "wood" : "clad";

  return {
    chipMaterial,
    variant,
    checkMark,
    handleClick,
    woodObj,
    largeScreen,
    materialChoice,
    doorType,
    woodSpecies
  };
}

export default useWoodSelector;
